// extracted by mini-css-extract-plugin
export default {"menu":"HeaderDropdownMenu_menu__asspB","open":"HeaderDropdownMenu_open__jt8vW","active":"HeaderDropdownMenu_active__eJ9A5"};